import React, { useState, Fragment } from 'react';
import { Badge, Col } from "reactstrap";
import { createThirdwebClient } from "thirdweb";
import {
    ConnectButton,
    TransactionButton,
    useActiveWalletConnectionStatus,
    useActiveAccount,
    useWalletBalance,
    useActiveWallet 
} from "thirdweb/react";
import { createWallet } from "thirdweb/wallets";
import { sepolia } from "thirdweb/chains"
import { ContractAbi } from '../../../contract/Abi';
import { ContractConstants } from '../../../constants/contract';
import { THIRDWEBConstants } from '../../../constants/thirdweb';
import { getContract, prepareContractCall, toWei } from "thirdweb";

/**
 * Blockchain Initial deposit component
 * 
 * Executed by Homeowner before Contractor starts to work
 */
export function ContractDepositButton({contractBc, onAction, onSuccess, onError}) {
    const [waitingForWallet, setWaitingForWallet] = useState(false);

    const client = createThirdwebClient({ clientId: THIRDWEBConstants.CLIENT_ID });
    const wallets = [createWallet("io.metamask")];
    const wallet = useActiveWallet();
    const walletChain = wallet?.getChain();
    const activeAccount = useActiveAccount();
    const walletAddress = activeAccount?.address;
    const { data } = useWalletBalance({client, chain: walletChain, address: walletAddress});
    const balance = parseFloat(data?.displayValue);
    const walletConnectionStatus = useActiveWalletConnectionStatus();
    const walletName = wallet?.walletName;
    const walletConnected = walletConnectionStatus === 'connected';
    const walletsMatch = activeAccount?.address.toLowerCase() === contractBc?.contract.homeowner?.toLowerCase();
    const enoughBalance = (balance - contractBc?.contract?.price) >= 0;

    const getPreparedDepositContractCall = () => {
        const contract = getContract({
            client,
            chain: sepolia,
            address: contractBc?.contract.address,
            abi: ContractAbi
        });

        return prepareContractCall({
            contract,
            method: ContractConstants.METHOD.DEPOSIT,
            params: [],
            value: toWei(contractBc?.contract?.price.toString())
        });
    }

    return (
        <Fragment>
            <div className='col-sm-6'>
                {
                    !walletConnected ? (
                        "Please connect your wallet to make the initial deposit"
                    ) : (
                        walletsMatch ? (
                            <Fragment>
                                <div>
                                    <span>Make Initial deposit</span>
                                </div>
                                <span>
                                    Amount
                                    <span className='text-success'>
                                        &nbsp;{ contractBc?.contract?.price } ETH
                                    </span>
                                </span>
                                <Badge color="secondary" className='text-wrap text-start w-100 mb-2 mb-md-0'>
                                    This action will transfer { contractBc?.contract?.price } { balance?.data?.name } from your connected wallet to the contract
                                </Badge>
                            </Fragment>
                        ) : (
                            "The current connected account does not match the contract " +
                            "address. Please switch to the correct account to make the initial deposit."
                        )
                    )
                }
            </div>
            <div className='col-sm-6 d-table'>
                {
                    walletsMatch ? (
                        enoughBalance ? (
                            <div className='d-table-cell align-middle'>
                                <TransactionButton
                                    className='w-100'
                                    theme={'light'}
                                    transaction={() => {
                                        return getPreparedDepositContractCall();
                                    }}
                                    onTransactionConfirmed={(receipt) => {
                                        setWaitingForWallet(false);
                                        if (typeof onSuccess === 'function') {
                                            onSuccess(receipt);
                                        }
                                    }}
                                    onError={(error) => {
                                        setWaitingForWallet(false);
                                        if (typeof onError === 'function') {
                                            onError(error);
                                        }
                                    }}
                                >
                                    Make Initial Deposit
                                </TransactionButton>
                                {
                                    waitingForWallet &&
                                    <Badge color="info" className='badge-outlined text-wrap text-start'>
                                        Waiting for {walletName ?? 'your wallet'} to confirm the transaction ...
                                    </Badge>
                                }
                            </div>
                        ) : (
                            balance?.data !== undefined ? (
                                <Fragment>
                                    <span>
                                        Your current wallet balance of
                                        <span className='text-danger'>
                                            &nbsp;
                                            { parseFloat(balance?.data.displayValue).toFixed(4) }
                                            &nbsp;
                                            { balance?.data.symbol }
                                            &nbsp;
                                        </span>
                                        is not enough to perform this operation.
                                    </span>
                                </Fragment>
                            ) : (
                                ''
                            )
                        )
                    ) : (
                            <Col className='text-center'>
                                <ConnectButton
                                    className='w-100'
                                    theme={'light'}
                                    client={client}
                                    wallets={wallets}
                                    connectModal={{ size: "compact" }}
                                    btnTitle='Connect your wallet'
                                />
                            </Col>
                    )
                }
            </div>
        </Fragment>
    );
}